import { SummerCampaign } from '@/models/leaderboard';
import { Routes } from '@/router';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'CmgLeaderboardPoints',
})
export default class CmgLeaderboardPoints extends Vue {
  get isInErrorState(): boolean {
    return this.$appStore.state.leaderboard.isInErrorState;
  }

  get points(): number {
    return this.$appStore.state.leaderboard.achievements.totalPointsEarned;
  }

  get currentMonthIndex(): number {
    // To assist in testing - at least a month index of 5 - June since campaigns start in June, but development occurring in May
    return Math.max(5, new Date().getMonth());
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get pointsBoxImg(): string | undefined {
    if (this.currentMonthIndex === 5) {
      return !this.isMobile
        ? this.$appStore.state.cms.images.loyalty.leaderboardPinkYellowBoxLong.desktop
        : this.$appStore.state.cms.images.loyalty.leaderboardPinkYellowBoxLong.mobile;
    } else if (this.currentMonthIndex === 6) {
      return !this.isMobile
        ? this.$appStore.state.cms.images.loyalty.leaderboardGreenYellowBoxLong.desktop
        : this.$appStore.state.cms.images.loyalty.leaderboardGreenYellowBoxLong.mobile;
    } else if (this.currentMonthIndex === 7) {
      return !this.isMobile
        ? this.$appStore.state.cms.images.loyalty.leaderboardBlueGreenBoxLong.desktop
        : this.$appStore.state.cms.images.loyalty.leaderboardBlueGreenBoxLong.mobile;
    }
  }

  get leaderboardWhiteBoxImg(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxPointsEarned.default;
  }

  get description(): string {
    if (this.isLastChallenge && this.isChallengeComplete) {
      return 'Every milestone, done. Thanks for making this summer extra with us.';
    } else if (this.isChallengeComplete) {
      return 'You crushed it. Come back next month for a fresh set of milestones to conquer';
    } else {
      return 'Every purchase with an entrée unlocks a milestone. Up to two orders per day count.';
    }
  }
  get isChallengeComplete(): boolean {
    if (this.summerCampaign !== undefined) {
      return this.summerCampaign!.milestones.filter((x) => !x.completed).length === 0;
    }
    return false;
  }

  get isLastChallenge(): boolean {
    // campaigns are ordered from earliest to latest in the leaderboard.service
    const lastCampaignMonth = this.$appStore.state.leaderboard.summerCampaigns.slice(-1)[0]?.month;
    return this.currentMonthIndex === lastCampaignMonth;
  }

  get summerCampaign(): SummerCampaign | undefined {
    return this.$appStore.state.leaderboard.summerCampaigns.find((x) => x.month === this.currentMonthIndex);
  }

  onClickCta() {
    this.$router.push({ name: Routes.Order, hash: '#menu' });
  }
}
